// Shared wrapper for icon components backed by a raster image (e.g. EntityBuilding,
// SelfDirectedIra) rather than an inline SVG. Renders as a native <button> (real
// keyboard/mouse/touch support, no ARIA-role workaround needed) when clickable;
// otherwise a plain <span>, since it's then purely decorative.
export const ImageIcon = (props) => {
  const { src, size = 24, onClick, verticalAlign, marginLeft, marginRight, top, className = ' ' } = props;
  const Wrapper = onClick ? 'button' : 'span';
  const wrapperStyle = onClick
    ? { marginLeft, marginRight, top, background: 'none', border: 'none', padding: 0, cursor: 'pointer' }
    : { marginLeft, marginRight, top };
  return (
    <Wrapper type={onClick ? 'button' : undefined} onClick={onClick} className={`icon-wrap ${className}`} style={wrapperStyle}>
      <img src={src} alt='' style={{ verticalAlign, width: size, height: size }} />
    </Wrapper>
  );
};
